import {ZodObject, ZodRawShape} from 'zod'
import {useParams} from 'react-router-dom'

export const useURLParsedParams = <T extends ZodRawShape>(paramsSchema: ZodObject<T>) => {
    const params = useParams()
    return paramsSchema.safeParse(params)
}
